module.exports = __webpack_public_path__ + "static/media/8101.95ced263.jpg";